import { render, staticRenderFns } from "./TellUs.vue?vue&type=template&id=572a4e84"
import script from "./TellUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TellUs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TellUs.vue?vue&type=style&index=0&id=572a4e84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports